import { BlockType } from '../../types/api/ElementType';
import { FetchType } from '../../types/api/FetchType';
import IForm from '../../types/IForm';
import ILink from '../../types/ILink';
import { CategoryImage } from '../../types/api/ImageType';
import { AnnouncementCreateOrUpdateForm } from './forms/AnnouncementCreateOrUpdate/AnnouncementCreateOrUpdate';

export type AnnouncementConfirmationInfo = {
  confirmationInfo: {
    confirmed: number;
    unconfirmed: number;
  };
};

type RecipientWithLink = {
  link: ILink;
};

export type RecipientWithoutLink = {
  name: string;
};

export const isRecipientWithoutLink = (recipient: any): recipient is RecipientWithoutLink => 'name' in recipient;

export type AnnouncementRecipients = {
  recipients?: {
    sendToAll: boolean;
    // each array entry can have only one or the other property
    recipientList: Array<RecipientWithLink | RecipientWithoutLink>;
  };
};

// This is currently the complete Announcement prop for every blockType.
// TODO: Refactor Announcements for each BlockType in order to use each announcementType for a specific block
// in future: OutBoxBlock should have its own Type for mandatory Announcements ( where mandatory is only possible)
// so we can make Announcement List Generic and Compose Components like:
//
// function AnnouncementsOutbox({ views }) {
//   return (
//       <AnnouncementList announcements={announcements} modifier= {'vertical'}>
//         (announcements) => <AnnouncementMandatory {...} />
//       </AnnouncementList>
//     )
// }

type AnnouncementCategoryProps = {
  id: string;
  title: string;
  image?: CategoryImage
};

export type AnnouncementProps = {
  id: string;
  title: string;
  allDay: boolean;
  editModeActive: boolean;
  elementType:
    | BlockType.allannouncementsoutbox
    | BlockType.allannouncementsinbox
    | BlockType.currentannouncementsinbox
    | BlockType.currentannouncementsoutbox
    | BlockType.currentmandatoryannouncementsforpage;

  text?: string;
  titleUrl?: string;
  startDate?: string;
  mandatory?: boolean;
  analysis?: { fetchType: FetchType; fetchUrl: string };
  confirmForm?: IForm;
  confirmUrl?: string;
  editForm?: AnnouncementCreateOrUpdateForm;
  deleteForm?: IForm;
  confirmed?: boolean;
  sender?: ILink;
  category?: AnnouncementCategoryProps;
} & Partial<AnnouncementConfirmationInfo> &
AnnouncementRecipients;

export type FormsComboBoxMultiSelectTypeParameter = {
  required: boolean;
  selectedItems: any[];
  addParameterToSelectedList: (selectedItem: any, maxSelectableItems?: any, addAtPosition?: string) => void;
  initializeKeywordParameter: () => void;
  removeParameterByTitle: (title: string) => void;
  removeParameterById: (selectedItem: any) => void;
  hasReadProtectedItems: boolean;
  name: string;
  onChange: () => void;
  onSortOrderChanged: (list: any[]) => void;
  comboBoxUrl: {
    url: string;
  };
  constraints?: {
    required?: boolean;
    maxLength?: number;
  };
};
